import PropTypes from "prop-types";
import React from "react";
//
import { Spin } from "@arco-design/web-react";
import { AuthContext } from "./auth-context";

// ----------------------------------------------------------------------

export function AuthConsumer({ children }) {
    return (
        <AuthContext.Consumer>
            {(auth) => ( auth.loading ? <div
                    style={{
                        minHeight: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "transparent"
                    }}
                >
                    <Spin dot  size={12}/>
                </div> : children )}
        </AuthContext.Consumer>
    );
}

AuthConsumer.propTypes = {
    children: PropTypes.node
};
